import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ModernHeader from './components/ModernHeader';
import MaintenanceBanner from './components/MaintenanceBanner';
import ProtectedRoute from './components/ProtectedRoute';
import './index.css';

import HomePage from './pages/HomePage';
import CoursesPage from './pages/CoursesPage';
import CourseDetailPage from './pages/CourseDetailPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import LearnPage from './pages/LearnPage';
import MyLearningPage from './pages/MyLearningPage';
import MockTestsPage from './pages/MockTestsPage';
import NotesPage from './pages/NotesPage';
import ResourceDetailPage from './pages/ResourceDetailPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'; // Import
import TermsOfServicePage from './pages/TermsOfServicePage'; // Import
import CancellationRefundPage from './pages/RefundPolicyPage'
import ContactUsPage from './pages/ContactUsPage';
import Footer from './components/Footer'
import { Style } from '@mui/icons-material';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <ModernHeader />

          

          <main className="pt-16 min-h-screen bg-gray-50">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/courses" element={<CoursesPage />} />
              <Route path="/courses/:courseId" element={<CourseDetailPage />} />
              <Route path="/mock-tests" element={<MockTestsPage />} />
              <Route path="/notes" element={<NotesPage />} />

              <Route path="/mock-tests/:id" element={<ResourceDetailPage />} />
              <Route path="/notes/:id" element={<ResourceDetailPage />} />
              <Route path="/resources/:id" element={<ResourceDetailPage />} />

              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms-of-service" element={<TermsOfServicePage />} />
              <Route path="/cancellation-and-refunds" element={<CancellationRefundPage />} />
              <Route path="/contact-us" element={<ContactUsPage />} />
              
              {/* Protected Routes */}
              <Route 
                path="/learn/:courseId"
                element={
                  <ProtectedRoute>
                    <LearnPage />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/my-learning"
                element={
                  <ProtectedRoute>
                    <MyLearningPage />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>
          <Footer></Footer>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
